/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";

// Reusable Components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import TransparentBlogCard from "reusables/Cards/BlogCards/TransparentBlogCard";
import BackgroundBlogCard from "reusables/Cards/BlogCards/BackgroundBlogCard";
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Images
import regular1 from "assets/images/Services/Residential/regular1.jpg";
import regular2 from "assets/images/Services/Residential/regular2.jpg";
import regular3 from "assets/images/Services/Residential/regular3.jpg";
import regular4 from "assets/images/Services/Residential/regular4.jpg";
import regular5 from "assets/images/Services/Residential/regular5.jpg";

function Residential_Section1() {
  return (
    <Container>
      <SubTitleContents title="Regular Cleaning Plans" contents="" />
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} lg={4}>
          <TransparentBlogCard
            image={regular1}
            title="Daily Cleaning"
            description="Perfect for busy households that require a spotless home every day. Our daily cleaning service ensures your living spaces are always fresh, hygienic, and inviting, giving you more time to focus on what matters most."
            action={{
              type: "internal",
              route: "/",
              color: "info",
              // label: "read more",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <TransparentBlogCard
            image={regular3}
            title="Weekly Cleaning"
            description="Enjoy a consistently spotless and refreshed home with our weekly cleaning service, perfect for busy households that value a clean and inviting space."
            action={{
              type: "internal",
              route: "/",
              color: "info",
              // label: "read more",
            }}
            popular={true}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <TransparentBlogCard
            image={regular4}
            title="Fortnightly Cleaning"
            description="Maintain a tidy and organized home effortlessly with our fortnightly cleaning service—ideal for those who need support every other week to keep their living space looking its best."
            action={{
              type: "internal",
              route: "/",
              color: "info",
              // label: "read more",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <TransparentBlogCard
            image={regular5}
            title="Monthly Cleaning"
            description="Keep your home fresh and dust-free with our monthly cleaning service, designed for homes that require occasional deep cleaning and regular maintenance."
            action={{
              type: "internal",
              route: "/",
              color: "info",
              // label: "read more",
            }}
          />
        </Grid>
        <Grid item xs={12} lg={8}>
          <BackgroundBlogCard
            image={regular2}
            title="Tailored Cleaning Plans"
            description="Customized cleaning schedules designed to fit your unique needs and lifestyle-flexible, reliable, and just the way you like it"
            // action={{
            //   type: "internal",
            //   route: "/",
            //   label: "read more",
            // }}
          />
        </Grid>
      </Grid>
    </Container>

    // <Container>
    //   <Grid
    //     container
    //     alignItems="center"
    //     // bgcolor={"red"}
    //     width={"100%"}
    //   >
    //     <Grid item>
    //       <MKTypography variant="h3" my={1}>
    //         Regular Basis
    //       </MKTypography>
    //       <MKTypography variant="body1" color="text" mb={2}>
    //         There&apos;s plenty reasons why our homes should be cleaned regularly, if not for our health and well-being, but also for the fact that it&apos;s less stressful and time-consuming when your home is neat and organized.
    //       </MKTypography>
    //     </Grid>
    //     <Grid>
    //       <Stack>
    //         <MKBox display="flex" alignItems="center" py={2}>
    //           <MKBox
    //             width="3rem"
    //             height="3rem"
    //             variant="gradient"
    //             bgColor="info"
    //             color="white"
    //             coloredShadow="info"
    //             display="flex"
    //             alignItems="center"
    //             justifyContent="center"
    //             borderRadius="100px"
    //           >
    //             <Icon fontSize="small">diversity_1</Icon>
    //           </MKBox>
    //           <MKBox display="flex" flexDirection="column">
    //             <MKBox>
    //               <MKTypography variant="body1" color="text" pl={2}>
    //                 Weekly Cleaning
    //               </MKTypography>
    //             </MKBox>
    //             <MKBox>
    //               <MKTypography variant="body2" color="text" pl={2}>
    //                 Get a refreshing top-up on a weekly basis for busy professionals and families
    //               </MKTypography>
    //             </MKBox>
    //           </MKBox>
    //         </MKBox>
    //         <MKBox display="flex" alignItems="center" py={2}>
    //           <MKBox
    //             width="3rem"
    //             height="3rem"
    //             variant="gradient"
    //             bgColor="info"
    //             color="white"
    //             coloredShadow="info"
    //             display="flex"
    //             alignItems="center"
    //             justifyContent="center"
    //             borderRadius="100px"
    //           >
    //             <Icon fontSize="small">diversity_1</Icon>
    //           </MKBox>
    //           <MKBox display="flex" flexDirection="column">
    //             <MKBox>
    //               <MKTypography variant="body1" color="text" pl={2}>
    //                 Weekly Cleaning
    //               </MKTypography>
    //             </MKBox>
    //             <MKBox>
    //               <MKTypography variant="body2" color="text" pl={2}>
    //                 Get a refreshing top-up on a weekly basis for busy professionals and families
    //               </MKTypography>
    //             </MKBox>
    //           </MKBox>
    //         </MKBox>
    //         <MKBox display="flex" alignItems="center" py={2}>
    //           <MKBox
    //             width="3rem"
    //             height="3rem"
    //             variant="gradient"
    //             bgColor="info"
    //             color="white"
    //             coloredShadow="info"
    //             display="flex"
    //             alignItems="center"
    //             justifyContent="center"
    //             borderRadius="100px"
    //           >
    //             <Icon fontSize="small">diversity_1</Icon>
    //           </MKBox>
    //           <MKBox display="flex" flexDirection="column">
    //             <MKBox>
    //               <MKTypography variant="body1" color="text" pl={2}>
    //                 Weekly Cleaning
    //               </MKTypography>
    //             </MKBox>
    //             <MKBox>
    //               <MKTypography variant="body2" color="text" pl={2}>
    //                 Get a refreshing top-up on a weekly basis for busy professionals and families
    //               </MKTypography>
    //             </MKBox>
    //           </MKBox>
    //         </MKBox>
    //       </Stack>
    //     </Grid>
    //   </Grid>
    // </Container>
  );
}

export default Residential_Section1;
